import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueResource from 'vue-resource'
import titleMixin from './mixins/titleMixin'
import VueCookies from 'vue-cookies'
import * as VueGoogleMaps from 'vue2-google-maps'
// import { rtdbPlugin } from 'vuefire'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import VueFbCustomerChat from 'vue-fb-customer-chat'
import { headersNoAuth } from './links.js'

Vue.prototype.window = window

Vue.config.productionTip = false

if (process.env.NODE_ENV !== 'development') {
  Vue.config.errorHandler = function (err, vm, info) {
    sendExceptionLog(err, info, 'error')
  }
  Vue.config.warnHandler = function (msg, vm, trace) {
    sendExceptionLog(msg, trace, 'warning')
  }
}

function sendExceptionLog (msg, trace, severity) {
  const payload = {
    message: msg,
    url: window.location.href,
    applicationType: 'web',
    severity: severity,
    stacktrace: trace,
    username: null
  }
  const url = 'http://dev-booking-engine.fare33.com/api/applicationLog'
  const params = {
    headers: headersNoAuth(),
    body: JSON.stringify(payload),
    method: 'POST'
  }
  fetch(url, params)
}

Vue.component('date-picker', DatePicker)

// Vue.use(rtdbPlugin)
Vue.use(VueFbCustomerChat, {
  page_id: 100947741485424,
  theme_color: '#2F80C2',
  locale: 'en_US'
})
Vue.use(VueResource)
Vue.mixin(titleMixin)
Vue.use(VueCookies)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCMpLmI6ZbrtqkEA_hIP7aWCJvRsCLz11c',
    libraries: 'places' // necessary for places input
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
